<template>
  <div class="about">
    <van-loading color="#0094ff" vertical>加载中..</van-loading>
  </div>
</template>
<script>
import { v4 as uuidv4 } from "uuid";

const { setPromotionGoodsCache } = require("../utils/promotionGoodsCache");

export default {
  data() {
    return {};
  },
  mounted() {
    let location = window.location.href;
    // let location = "https://testm.sz-adtop.com/#/?p_code=TPStaaamy_w_c";
    // let location = "https://testp.sz-adtop.com?p_code=Puutvvg&union_site=__UNION_SITE__";
    sessionStorage.setItem("location_url", location);
    var objs = this.parseHashQueryParameters(location);
    this.p_code = objs.p_code.replace(/#\//, "");
    this.getProduct(this.p_code);
  },
  methods: {
    parseHashQueryParameters(url) {
      const lastIndexOfQuestionMark = url.lastIndexOf("?");
      if (lastIndexOfQuestionMark === -1) {
        return {};
      }

      const queryString = url.slice(lastIndexOfQuestionMark + 1);
      const params = new URLSearchParams(queryString);
      const result = {};
      for (const [key, value] of params) {
        result[decodeURIComponent(key)] = decodeURIComponent(value);
      }
      return result;
    },
    getProduct(data) {
      let param = {
        p_code: data,
      };
      this.$http
        .post("mapi/promotion/getGoods", param)
        .then((res) => {
          if (!localStorage.getItem("app_device_uuid")) {
            let device_str = uuidv4();
            localStorage.setItem("app_device_uuid", device_str);
          }
          setPromotionGoodsCache({
            pCode: this.p_code,
            templateWebUrl: res.data.goods.template_web_url,
            responseData: res.data,
          });
          if (res.data.goods.form_need == 2 && res.data.template_data.set.is_mod == 1) {
            this.$router.push({
              path: "/taiKangindex",
              query: {
                p_code: this.p_code,
                c_code: res.data.goods.code,
                order_number: res.data.order_number,
              },
            });
            return;
          }
          if (
            res.data.goods.template_web_url == "transferPage" ||
            res.data.goods.template_web_url == "transferPage1"
          ) {
            this.$router.push({
              path: "/" + res.data.goods.template_web_url,
              query: {
                p_code: this.p_code,
                c_code: res.data.goods.code,
                phone: this.phoneNumber,
                order_number: res.data.order_number,
              },
            });
          } else {
            this.$router.push({
              path: "/" + res.data.goods.template_web_url,
              query: { p_code: this.p_code },
            });
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="scss">
.about {
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
